import { SHOW_ALL_FIELDS } from '../constants';

function requireAddressType(selectedFieldSet) {
  return selectedFieldSet === SHOW_ALL_FIELDS;
}

export default requireAddressType;
